import { Env } from '@didi/utils'
import { getLoginSDK } from '../core/login'

const ERR_OK = 0

function passengerForceLogin(sdk, config, callback) {
  sdk.call('requestLogin', {}, (err, ret) => {
    if (err.errno !== ERR_OK) {
      callback && callback(err)
    } else {
      callback && callback(null, ret)
    }
  })
}

function driverForceLogin(sdk, config, callback) {
  /*
   * Do nothing
   * 司机端 Bridge 没有拉起登录的 API
   */
}

function webForceLogin(sdk, config, callback) {
  sdk.setConfig(config)

  sdk.forceLogin((ret) => {
    callback && callback(null, {
      phone: ret.cell,
      token: ret.ticket
    })
  }, error => {
    callback && callback(error)
  })
}

export function forceLogin(config, callback) {
  getLoginSDK(config)
    .then(sdk => {
      if (Env.isPassenger) {
        passengerForceLogin(sdk, config, callback)
      } else if (Env.isDriver) {
        driverForceLogin(sdk, config, callback)
      } else {
        webForceLogin(sdk, config, callback)
      }
    })
    .catch(error => {
      console.log(error)
    })
}

export default forceLogin